import { render, staticRenderFns } from "./historique.vue?vue&type=template&id=6063a7b1"
import script from "./historique.vue?vue&type=script&lang=js"
export * from "./historique.vue?vue&type=script&lang=js"
import style0 from "./historique.vue?vue&type=style&index=0&id=6063a7b1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports